import React from 'react';
import { Select } from 'antd';
import { shutdownResponsibleQuery } from '../../../../../../shared/api/queries';
import Field, { fieldTypes } from '../../../../../../shared/ui/Field';
import getName from '../../../../../../../../helpers/getName';
import { fieldNames } from '../../../config';
import BlockWithExtraContent from '../../../../../../../../components/BlockWithExtraContent/BlockWithExtraContent';
import {
  useSetSelectValueSubscription,
  valueTypes,
} from '../../../lib/subscriptions';

const { useShutdownResponsible } = shutdownResponsibleQuery;
const { Option } = Select;
const fieldName = fieldNames.responsible;

const ResponsibleField = ({ form, initialValue, editMode, companyId }) => {
  const company = editMode ? [companyId] : [];

  const { data, isFetching } = useShutdownResponsible(company, {
    staleTime: Infinity,
  });

  useSetSelectValueSubscription({
    fieldName,
    data,
    valueType: valueTypes.arrayNumber,
    form,
  });

  return (
    <Field
      fieldType={fieldTypes.select}
      form={form}
      name={fieldName}
      label="Ответственные"
      decoratorOptions={{
        initialValue: data?.length && !editMode ? initialValue : [],
        rules: editMode
          ? [
              {
                required: true,
                message: 'Укажите ответственных',
                type: 'array',
              },
            ]
          : [],
      }}
      fieldProps={{
        placeholder: 'Выберите ответственных',
        loading: isFetching,
        optionFilterProp: 'searchtext',
        optionLabelProp: 'label',
        mode: 'multiple',
        dropdownMatchSelectWidth: false,
      }}
      items={
        editMode && initialValue?.length
          ? data?.filter((item) => !initialValue.includes(item.id)) || []
          : data
      }
      renderOption={(item) => {
        const name = getName(item);
        const speciality = item.specialityName;

        return (
          <Option
            key={item.id}
            value={item.id}
            searchtext={`${name}${speciality || ''}`}
            label={name}
          >
            <BlockWithExtraContent
              main={name}
              extra={speciality}
            />
          </Option>
        );
      }}
    />
  );
};

export default ResponsibleField;
